import React from 'react';

const PricingCard = ({ 
  planName, 
  priceMonthly, 
  priceQuarterly, 
  features, 
  ctaText, 
  trialInfo, 
  isCurrentPlan = false, 
  onSubscribe, 
  loading = false,  // Default value to prevent undefined
  disabled = false  // New prop to handle disabled state
}) => {
  return (
    <div className={`bg-white shadow-lg rounded-xl p-6 flex flex-col justify-between hover:shadow-2xl transition-all duration-300 ease-in-out ${isCurrentPlan ? 'border-2 border-indigo-600' : ''}`}>
      <div>
        <h3 className="text-2xl font-semibold text-gray-900 mb-2">{planName}</h3>
        {trialInfo && (
          <span className="inline-block bg-gradient-to-r from-green-400 to-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase mb-4">
            {trialInfo}
          </span>
        )}
        <div className="mb-6">
          <p className="text-4xl font-extrabold text-gray-900">{priceMonthly}</p>
          {priceMonthly !== 'Free' && <p className="text-sm text-gray-500">per month</p>}
          {priceQuarterly && (
            <p className="text-md text-gray-700 mt-1">{priceQuarterly} <span className="text-sm text-gray-500">quarterly</span></p>
          )}
        </div>
        <ul className="space-y-3 mb-8 text-gray-600">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <svg className="flex-shrink-0 h-6 w-6 text-green-500 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      <button
        className={`w-full py-3 px-6 text-lg font-semibold rounded-lg transition-colors duration-300 
                    ${isCurrentPlan 
                      ? 'bg-gray-300 text-gray-700 cursor-not-allowed' 
                      : disabled 
                        ? 'bg-gray-400 text-white cursor-not-allowed' 
                        : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'}
                    ${loading ? 'opacity-75 cursor-wait' : ''}`}
        disabled={isCurrentPlan || loading || disabled}
        onClick={(e) => {
          e.preventDefault();
          if (!isCurrentPlan && !disabled && onSubscribe) {
            onSubscribe();
          }
        }}
      >
        {loading ? (
          <span className="flex items-center justify-center">
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Processing...
          </span>
        ) : ctaText}
      </button>
    </div>
  );
};

export default PricingCard;
